import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  H5,
  HTMLSelect,
  HTMLTable,
  Icon,
  InputGroup,
  Popover,
  Switch,
  Tab,
  Tabs,
  Tooltip,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { api_adm } from "../../api";
import { ICalc } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { toast } from "react-toastify";
import * as moment from "moment";
import {
  MDBBtn,
  MDBCol,
  MDBRow,
} from "mdbreact";
import { CalcsClassificacaoPage } from "./CalcsClassificacao";
import { CalcRSStore } from "../../stores/calculo-rs/CalcRSStore";
import { handleValidCalcs } from "../../utils";
import { BootstrapTable, TableHeaderColumn, SearchField } from "react-bootstrap-table";
import InfoModal from "../info-modal/InfoModal";
import { AppIcon } from "../utils/AppIcon";

interface CalcRsPageProps { }

interface CalcRsPageState {
  listIdsClass: any[];
}

@observer
export class CalcRsPage extends React.Component<CalcRsPageProps, CalcRsPageState> {
  obs = observable({
    duplicateName: "" as string,
    modalCreateClassificacao: false as boolean,
    codigo_receita: "" as string,
    codigo_ajuste: "" as string,
    nome_classificacao: "" as string,
    filter_vigencia: "vigentes" as string,
    dae_avulso: false as boolean,
    open_ajuda: false as boolean,
    cod_or: "" as string,
    open_select_class: false as boolean,
    apuracao_saida: false as boolean,
  })

  constructor(props) {
    super(props);

    this.state = {
      listIdsClass: [],
    }

  }

  async componentDidMount() {

    AppStore.setTitle("Formas de Cálculo Rio Grande do Sul");

    await CalcRSStore.handleCalcFiltered(CalcRSStore.obs.tipo, CalcRSStore.obs.filterText, this.obs.filter_vigencia);

  }

  handleCreate = () => {
    AppStore.setLocation("/calc-rs/create");
  };


  handleChangeVigencia(e: string) {
    this.obs.filter_vigencia = e;
    CalcRSStore.handleCalcFiltered(CalcRSStore.obs.tipo, CalcRSStore.obs.filterText, this.obs.filter_vigencia)
  }

  async handleChangeTab(tableId) {
    CalcRSStore.obs.tipo = tableId

    if (tableId == "classificacao") { CalcRSStore.obs.filterText = "" }

    if (tableId != "classificacao") {
      await CalcRSStore.handleCalcFiltered(tableId, CalcRSStore.obs.filterText, this.obs.filter_vigencia)
    }

  }

  async handleDelete(calc: ICalc) {
    try {
      let params = { id: calc._id, tipo: CalcRSStore.obs.tipo }

      await api_adm.post(`/api/admin/calcs-rs/delete`, params);
      toast.success(`Cálculo excluído: ${calc.nome}`, {});
      CalcRSStore.handleCalcFiltered(CalcRSStore.obs.tipo, CalcRSStore.obs.filterText, this.obs.filter_vigencia);

      if (calc.contas_id) {
        CalcRSStore.obs.tipo = "contas"
        CalcRSStore.handleCalcFiltered(CalcRSStore.obs.tipo, CalcRSStore.obs.filterText, this.obs.filter_vigencia);
      } else if (calc.entrada) {
        CalcRSStore.obs.tipo = "entrada"
        CalcRSStore.handleCalcFiltered(CalcRSStore.obs.tipo, CalcRSStore.obs.filterText, this.obs.filter_vigencia);
      } else if (calc.saida) {
        CalcRSStore.obs.tipo = "saida"
        CalcRSStore.handleCalcFiltered(CalcRSStore.obs.tipo, CalcRSStore.obs.filterText, this.obs.filter_vigencia);
      } else {
        CalcRSStore.obs.tipo = "outros"
        CalcRSStore.handleCalcFiltered(CalcRSStore.obs.tipo, CalcRSStore.obs.filterText, this.obs.filter_vigencia);
      }
    } catch (ex) {
      toast.error(`Erro ao excluir Cálculo!`, {});
    }
  }

  handleEdit(calc: ICalc) {
    AppStore.setLocation(`/calc-rs/edit/${calc._id}/${CalcRSStore.obs.tipo}`);
  }

  async handleFilter(filter: string) {
    CalcRSStore.obs.filterText = filter
    let filtro = filter.toLowerCase()
    await CalcRSStore.handleCalcFiltered(CalcRSStore.obs.tipo, filtro, this.obs.filter_vigencia);
  }

  async handleDuplicate(calc: ICalc) {
    try {
      let params = {
        nome: this.obs.duplicateName,
        tipo: CalcRSStore.obs.tipo,
        id: calc._id
      }

      await api_adm.post(`/api/admin/calcs-rs/duplicate`, params);
      toast.success('Cálculo duplicado', {});
      CalcRSStore.handleCalcFiltered(CalcRSStore.obs.tipo, CalcRSStore.obs.filterText, this.obs.filter_vigencia);
    } catch (ex) {
      toast.error('Erro ao duplicar Cálculo!', {})
    }
  }

  handleRefresh() {
    window.location.reload();
  }

  handleSaveClassificacao = async () => {

    if (!this.obs.nome_classificacao) {
      toast.error('Preencha o nome da classificação`', {});
      return;
    }

    let params = {
      codigo_receita: this.obs.codigo_receita,
      codigo_ajuste: this.obs.codigo_ajuste,
      nome: this.obs.nome_classificacao,
      dae_avulso: this.obs.dae_avulso,
      estado: "RS",
      ids_calc_credito_entrada: [],
      cod_or: this.obs.cod_or ? this.obs.cod_or : null,
      apuracao_saida: this.obs.apuracao_saida,
      ids_cassificacao_self: this.state.listIdsClass
    };

    let resp = await CalcRSStore.createClassificacao(params)

    if (resp) {

      await CalcRSStore.handldeBuscaClassificacao();

      this.obs.modalCreateClassificacao = false;

    }

  };

  async handleCreateClass() {

    this.setState({ listIdsClass: [] });

    this.obs.codigo_receita = ""
    this.obs.nome_classificacao = ""
    this.obs.codigo_ajuste = ""
    this.obs.dae_avulso = false
    this.obs.cod_or = ""
    this.obs.apuracao_saida = false

    this.obs.modalCreateClassificacao = true;

  }

  createCustomSearchFieldSol = (props) => {
    return (
      <SearchField
        className="input-filter input-filter-sefa input-filter-calcs"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Nome)"
      />
    );
  };

  handleCheckClass = async (row, checked) => {

    if (checked) {

      this.setState(state => { state.listIdsClass.push(row.id) });

    } else {

      let index = this.state.listIdsClass.indexOf(row.id);

      this.state.listIdsClass.splice(index, 1);

    }

  };

  handleCheckClassAll = async (check, row) => {

    if (check) {

      this.setState({ listIdsClass: row?.map(value => value.id) });

    } else {

      this.setState({ listIdsClass: [] });
    }

  };

  render() {

    let itemns = handleValidCalcs(CalcRSStore.obs.calcs_index, CalcRSStore.obs.sub_tipo)?.map(calc => {
      return (
        <tr key={calc._id}>
          <td>{calc.index}</td>
          <td>{calc.prioridade}</td>
          <td>{calc.nome}</td>
          <td style={{ fontSize: 12 }}>
            {calc.valido_de &&
              <span>{moment(calc.valido_de).format("DD/MM/YYYY")}</span> ||
              <span>Sempre</span>}
            <Icon icon="arrow-right" style={{ margin: "0 5px" }} />
            {calc.valido_ate &&
              <span>{moment(calc.valido_ate).format("DD/MM/YYYY")}</span> ||
              <span>Sempre</span>}
          </td>
          <td className="nz-table-actions">
            <MDBBtn
              color="default"
              rounded
              size="sm"
              onClick={this.handleEdit.bind(this, calc)}
            >
              <img src="/images/edit.png" width={25} />
            </MDBBtn>
            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
              <Tooltip content="Duplicar">
                <MDBBtn
                  color="default"
                  rounded
                  size="sm"
                  onClick={() => this.obs.duplicateName = `Cópia de ${calc.nome}`}
                >
                  <img src="/images/duplicate.svg" width={25} />
                </MDBBtn>
              </Tooltip>
              <div>
                <H5>Duplicar cálculo: {calc.nome}</H5>
                <FormGroup
                  label="Nome"
                  labelFor="nome"
                >
                  <InputGroup
                    id="nome"
                    value={this.obs.duplicateName}
                    onChange={(e: any) => this.obs.duplicateName = e.target.value}
                  />
                </FormGroup>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 15,
                  }}
                >
                  <Button
                    className={Classes.POPOVER_DISMISS}
                    style={{ marginRight: 10 }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    intent="primary"
                    className={Classes.POPOVER_DISMISS}
                    onClick={this.handleDuplicate.bind(this, calc)}
                  >
                    Duplicar
                  </Button>
                </div>
              </div>
            </Popover>

            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
              <MDBBtn color="default" rounded size="sm">
                <img src="/images/bin.png" width={25} />
              </MDBBtn>
              <div>
                <H5>Confirmar exclusão?</H5>
                <p>Confirmar exclusão do cálculo {calc.nome}?</p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 15,
                  }}
                >
                  <Button
                    className={Classes.POPOVER_DISMISS}
                    style={{ marginRight: 10 }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    intent="danger"
                    className={Classes.POPOVER_DISMISS}
                    onClick={this.handleDelete.bind(this, calc)}
                  >
                    Excluir
                  </Button>
                </div>
              </div>
            </Popover>
          </td>
        </tr>
      );
    })

    const optionsClass = {
      searchField: this.createCustomSearchFieldSol,
    };

    const selectRowClass = {
      mode: "checkbox",
      clickToSelect: true,
      columnWidth: "40px",
      onSelect: this.handleCheckClass,
      onSelectAll: this.handleCheckClassAll,
      selected: this.state.listIdsClass,
    };

    let classificacoes = CalcRSStore.obs.itens_classificacao?.map(obj => {

      return ({
        id: (obj.id || obj._id),
        nome: obj.nome,
      })

    });

    return (<>
      <div style={{ marginBottom: 100 }}>
        <MDBRow>
          <MDBCol md="12">
            <MDBBtn className="btnDefault noFloat" onClick={this.handleCreate}>
              Criar Cálculo
            </MDBBtn>
            <MDBBtn
              className="btnDefault noFloat"
              onClick={(e) => this.handleCreateClass()}
              style={{ marginLeft: 15 }}
            >
              Criar Classificação
            </MDBBtn>
          </MDBCol>
          <MDBCol md="3" className="inputFilterCalcs">
            <InputGroup
              round
              leftIcon="search"
              placeholder="Filtrar (Nome)"
              style={{ borderRadius: "10px" }}
              value={CalcRSStore.obs.filterText}
              onChange={(e: any) => this.handleFilter(e.target.value)}
              disabled={CalcRSStore.obs.tipo == "classificacao"}
            />
          </MDBCol>
          <MDBCol md="2">
            <FormGroup
              label={"Filtro cálculos"}
              labelFor="pendente"
              className="selectVigencia"
            >
              <HTMLSelect
                value={this.obs.filter_vigencia}
                onChange={(e: any) => this.handleChangeVigencia(e.target.value)}
                disabled={CalcRSStore.obs.tipo == "classificacao"}
              >
                <option value="vigentes">Vigentes</option>
                <option value="vencidas">Vencidos</option>
                <option value="futuras">Futuras</option>
              </HTMLSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol md="12">
            <Tabs
              id="tabs"
              className={"tabsCalculos calcs"}
              onChange={(tableId) => this.handleChangeTab(tableId)}
              selectedTabId={CalcRSStore.obs.tipo}
            >
              <Tab id="entrada" title="Entrada" />
              <Tab id="saida" title="Saída" />
              <Tab id="outros" title="Outros" />
              <Tab id="contas" title="Exclusivos" />
              <Tab id="classificacao" title="Classificação" panel={<CalcsClassificacaoPage />} />
            </Tabs>
          </MDBCol>
        </MDBRow>

        {CalcRSStore.obs.tipo != "classificacao" &&
          <>
            <Tabs
              id="tabs"
              className={"tabsCalculos calcs"}
              onChange={(tableId) => CalcRSStore.obs.sub_tipo = String(tableId)}
              selectedTabId={CalcRSStore.obs.sub_tipo}
            >
              <Tab id="simples_nacional" title="Apenas Simples Nacional" />
              <Tab id="regime_e_sem_regime" title="Apenas Regime Normal" />
              <Tab id="simples_nacional_excesso" title="Apenas Regime Nacional Excesso" />
              <Tab id="regime_especial" title="Apenas Regime Especial" />
              <Tab id="outros" title="Outros" />
            </Tabs>

            <div className="TableDefault">
              <HTMLTable className="table table-hover dataTable" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th style={{ width: 100 }}>Código</th>
                    <th style={{ width: 100 }}>Prioridade</th>
                    <th>Nome</th>
                    <th style={{ width: 180 }} />
                    <th style={{ width: 180 }} />
                  </tr>
                </thead>
                <tbody>
                  {itemns}
                </tbody>
              </HTMLTable>
            </div>
          </>
        }

      </div>

      <Dialog
        isOpen={this.obs.modalCreateClassificacao}
        onClose={() => this.obs.modalCreateClassificacao = false}
        title="Criar nova classificação"
        className="AlertUser modalSefa"
      >
        <div className={Classes.DIALOG_BODY}>
          <div style={{ marginBottom: 10 }} className="AlertImportacoes">

            <MDBRow>

              <MDBCol>
                <FormGroup label="Código Receita" labelFor="codigo-receita" style={{ width: 300 }}>
                  <InputGroup
                    id="codigo-receita"
                    value={this.obs.codigo_receita}
                    onChange={(e: any) => this.obs.codigo_receita = e.target.value}
                  />
                </FormGroup>
              </MDBCol>

              <MDBCol>

                <FormGroup label="Código Ajuste" labelFor="codigo-ajuste" style={{ width: 300 }}>
                  <InputGroup
                    id="codigo-ajuste"
                    value={this.obs.codigo_ajuste}
                    onChange={(e: any) => this.obs.codigo_ajuste = e.target.value}
                  />
                </FormGroup>

              </MDBCol>
            </MDBRow>

            <FormGroup label="Nome" labelFor="nome" style={{ width: 300 }}>
              <InputGroup
                id="nome"
                value={this.obs.nome_classificacao}
                onChange={(e: any) => this.obs.nome_classificacao = e.target.value}
              />
            </FormGroup>

            <MDBRow>
              <MDBCol>
                <FormGroup label="Código do ICMS recolhido ou a recolher" style={{ width: 300 }}>
                  <HTMLSelect
                    onChange={(e) => this.obs.cod_or = e.target.value}
                    value={this.obs.cod_or}
                  >
                    <option value="">Selecione</option>
                    <option value="090">090 - Outras obrigações do ICMS</option>
                    <option value="000">000 - ICMS a recolher</option>
                    <option value="005">005 - Antecipação tributária</option>
                  </HTMLSelect>
                </FormGroup>
              </MDBCol>

              <MDBCol>
                <FormGroup label="Dae Avulso">
                  <Switch
                    label={this.obs.dae_avulso ? "Sim" : "Não"}
                    checked={this.obs.dae_avulso}
                    onChange={(e: any) =>
                      this.obs.dae_avulso = e.target.checked ? true : false}
                  />
                </FormGroup>
              </MDBCol>

              <MDBCol>
                <FormGroup label="Apuração Saída">
                  <Switch
                    label={this.obs.apuracao_saida ? "Sim" : "Não"}
                    checked={this.obs.apuracao_saida}
                    onChange={(e: any) =>
                      this.obs.apuracao_saida = e.target.checked ? true : false}
                  />
                </FormGroup>

              </MDBCol>
            </MDBRow>

            {this.obs.apuracao_saida
              ? <span><b style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => this.obs.open_select_class = true}>{"Selecione as Classificações >> "}</b>
                <AppIcon name="help" className="pulse-notification-pgdas" color="blue" style={{ cursor: "pointer", marginLeft: 5 }} onClick={() => this.obs.open_ajuda = true} />
              </span>
              : <></>
            }

          </div>
        </div>

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" onClick={() => this.obs.modalCreateClassificacao = false} />
            <Button text="Salvar" intent="primary" onClick={this.handleSaveClassificacao} />
          </div>
        </div>

      </Dialog>

      <Dialog
        isOpen={this.obs.open_select_class}
        onClose={() => this.obs.open_select_class = false}
        title="Classificações"
      >
        <div className={Classes.DIALOG_BODY}>
          <div className="select-empresa-sefa select-calcs">
            <BootstrapTable data={classificacoes} selectRow={selectRowClass} options={optionsClass} search>
              <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="nome" width="90%">Nome</TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" intent="primary" onClick={() => this.obs.open_select_class = false} />
          </div>
        </div>
      </Dialog>

      <InfoModal open={this.obs.open_ajuda} onClose={() => this.obs.open_ajuda = false} texto_info="Cálculos vinculados ao crédito pela entrada: se você estiver apurando a saída, o sistema buscará cada classificação da saída correspondente na entrada, apenas para os cálculos que você selecionar aqui." />

    </>);
  }
}

export default CalcRsPage;
